import classNames from 'classnames';
import React from 'react';
import { GridView, ListView } from '../../svgs/ExpressonSVGs';

export type CardsViewStyleValue = 'grid' | 'list';

type CardsViewStyleProps = {
    viewStyle: CardsViewStyleValue;
    onViewStyleChange: (viewStyle: CardsViewStyleValue) => void;
}

const CardsViewStyle: React.FC<CardsViewStyleProps> = ({
    viewStyle,
    onViewStyleChange
}) => {
    const [isAnimating, setIsAnimating] = React.useState(false)

    const showListView = viewStyle === 'list'

    const handleClick = () => {
        const next: CardsViewStyleValue = showListView ? 'grid' : 'list'
        setIsAnimating(true)
        onViewStyleChange(next)
    }

    const handleAnimationEnd = () => {
        setIsAnimating(false)
    }

    return (
        <div
            className={classNames(
                'cards-view-style',
                showListView ? 'list-view' : 'grid-view',
                isAnimating && (showListView ? 'animate-to-list' : 'animate-to-grid')
            )}
            onAnimationEnd={handleAnimationEnd}
        >
            <button onClick={handleClick} aria-label="Change view style">
                <GridView width={24} height={24} />

                <ListView width={24} height={27} />
            </button>

        </div>
    )
}

export default CardsViewStyle

